import {
  CerberusStatsFields,
  PropertyType,
  PropertyTypeEnum,
} from '@hcs/types';
import { logWarning } from '@hcs/utils';

import { LISTING_STATS_RENTAL_FIELDS } from '../constants';
import { CerberusStats } from '../types';

export const mapPropertyTypeToEnum = (
  propertyType: 'singleFamily' | 'condo' | undefined,
): PropertyType | undefined => {
  if (propertyType === 'condo') return PropertyType.Condo;
  if (propertyType === 'singleFamily') return PropertyType.SingleFamilyDetached;
  return undefined;
};

/**
 * Maps a property type string to a PropertyTypeEnum value.
 * Use this when the target GraphQL field expects PropertyTypeEnum
 * (e.g. rpi(propertyTypeEnum: ...) in the RPI time series queries).
 * NOTE: PropertyTypeEnum uses 'SFR' for single family, not 'SINGLE_FAMILY_DETACHED'.
 */
export const mapPropertyTypeToPropertyTypeEnum = (
  propertyType: 'singleFamily' | 'condo' | undefined,
): PropertyTypeEnum | undefined => {
  if (propertyType === 'condo') return PropertyTypeEnum.Condo;
  if (propertyType === 'singleFamily') return PropertyTypeEnum.Sfr;
  return undefined;
};

export const getRentalLabel = (fieldLabel: string): string => {
  return `Rental ${fieldLabel}`;
};

export const logValueUnsupportedWarning = (
  field: CerberusStatsFields,
  cerberusStats: CerberusStats,
) => {
  logWarning(
    `${field} getValue called with unsupported cerberusStatsType: ${cerberusStats?.type}`,
  );
};

export const getIsRentalListingStatsField = (
  field: CerberusStatsFields,
): boolean => {
  return LISTING_STATS_RENTAL_FIELDS.findIndex((f) => f === field) !== -1;
};
